/* PAIX-V1 FX: makes every page feel like a game.
   ITEM GET on add-to-cart, achievements, player HUD, CRT page start, live e-mail fields, sound toggle,
   PLAYER READY on login and the welcome bonus. */
(function () {
  if (window.__paixFx) return;
  window.__paixFx = true;

  var RATE = 10; // points per 1 EUR, keep in sync with the membership server config (shop metafield paix.loyalty_config)
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var B = document.body;
  var D = B ? B.dataset : {};
  var loggedIn = D.pxCustomer === '1';
  var isHome = D.pxTemplate === 'index';
  var LANG = (document.documentElement.lang || 'en').toLowerCase();
  var DA = LANG.indexOf('da') === 0;
  function T(en, da) { return DA ? da : en; }
  var CUR = (window.Shopify && Shopify.currency) || {};
  /* Prices on the page are in the visitor's currency; points are always earned per 1 EUR, so convert back */
  function toEur(a) { var r = Number(CUR.rate) || 1; return r > 0 ? a / r : a; }
  function money(a) {
    var c = CUR.active || 'EUR';
    if (c === 'EUR' && !DA) return '€' + a.toFixed(2).replace('.', ',');
    try { return new Intl.NumberFormat(DA ? 'da-DK' : 'en-GB', { style: 'currency', currency: c }).format(a); } catch (e) { return a.toFixed(2) + ' ' + c; }
  }

  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function sread(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssave(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function soundOn() { return read('pxSound') !== 'off'; }
  /* Sound is ON by default; players switch it off themselves with the SOUND button (Omar 15/10). A saved choice is kept.
     paix-game.js and the home arcade (paix-arcade.js) use the same pxSound value. */
  if (read('pxSound') === null) save('pxSound', 'on');
  function setSound(on) { save('pxSound', on ? 'on' : 'off'); document.dispatchEvent(new CustomEvent('px:sound')); }

  var css = document.createElement('style');
  css.textContent =
    '.pxfx{position:fixed;inset:0;z-index:2147483100;pointer-events:none;display:grid;place-items:center;overflow:hidden}' +
    '.pxfx__flash{position:absolute;inset:0;background:radial-gradient(circle at 50% 50%,rgb(140 200 255/.35),transparent 60%);animation:pxfx-flash .5s ease-out forwards}' +
    '.pxfx__box{position:relative;text-align:center;font-family:"Press Start 2P",monospace;color:#e2f0ff;padding:22px 28px;background:rgb(2 4 10/.88);border:3px solid #2f8bff;box-shadow:0 0 0 3px #000,0 0 40px rgb(47 139 255/.8),inset 0 0 24px rgb(47 139 255/.25);animation:pxfx-pop 1.7s steps(12) forwards}' +
    '.pxfx__title{font-size:clamp(20px,5vw,40px);letter-spacing:.06em;margin:0 0 12px;text-shadow:0 0 8px #2f8bff,0 0 24px #2f8bff,3px 3px 0 #3a3dff}' +
    '.pxfx__sub{font-size:10px;letter-spacing:.12em;color:#8cc8ff;margin:0}' +
    '.pxfx__px{position:absolute;left:50%;top:50%;width:6px;height:6px;background:#8cc8ff;box-shadow:0 0 8px #2f8bff}' +
    '.pxach{position:fixed;right:16px;bottom:16px;z-index:2147483050;display:flex;gap:12px;align-items:center;max-width:min(360px,calc(100vw - 32px));padding:12px 14px;background:#050c1a;border:2px solid #2f8bff;box-shadow:0 0 0 2px #000,0 0 24px rgb(47 139 255/.6);font-family:"Press Start 2P",monospace;color:#e2f0ff;animation:pxach-in 4.2s steps(10) forwards;pointer-events:none}' +
    '.pxach__icon{flex:none;width:34px;height:34px;display:grid;place-items:center;background:#2f8bff;color:#02040a;font-size:16px}' +
    '.pxach__k{font-size:7px;letter-spacing:.16em;color:#8cc8ff;margin:0 0 6px}.pxach__t{font-size:10px;line-height:1.5;margin:0}' +
    '.pxhud{position:relative;z-index:3;display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap;padding:7px 16px;font:9px/1.4 "Press Start 2P",monospace;letter-spacing:.12em;color:#8cc8ff;background:#02040a;border-bottom:1px solid rgb(47 139 255/.3)}' +
    '.pxhud a{color:#e2f0ff;text-decoration:none}.pxhud a:hover{text-shadow:0 0 8px #2f8bff}.pxhud b{color:#e2f0ff;font-weight:400}' +
    '.pxhud__blink{animation:pxblink 1.2s steps(1) infinite}' +
    /* F-28: ♪/♫ sit just under Shopify's cookie banner (z-index 2000000), so the whole Accept button can be tapped */
    '.pxsnd{position:fixed;left:12px;bottom:12px;z-index:1999000;min-height:34px;padding:8px 10px;font:8px/1 "Press Start 2P",monospace;letter-spacing:.1em;color:#8cc8ff;background:rgb(2 6 14/.9);border:2px solid rgb(47 139 255/.5);cursor:pointer}' +
    '.pxsnd[aria-pressed=true]{color:#e2f0ff;border-color:#2f8bff}' +
    '.pxcrt{position:fixed;inset:0;z-index:2147483200;pointer-events:none;background:#000;animation:pxcrt .42s steps(6) forwards}' +
    '.pxcrt::after{content:"";position:absolute;left:0;right:0;top:50%;height:2px;background:#e2f0ff;box-shadow:0 0 20px #2f8bff;animation:pxcrtl .42s ease-out forwards}' +
    'input.pxmail{transition:box-shadow 80ms steps(2)!important}input.pxmail.is-key{box-shadow:0 0 0 2px #2f8bff,0 0 18px rgb(47 139 255/.8)!important}' +
    'input.pxmail.is-valid{border-color:#8cc8ff!important}' +
    '.pxmail-meter{display:block;height:6px;margin-top:6px;background:#02040a;border:1px solid rgb(47 139 255/.5);visibility:hidden}.pxmail-meter.is-on{visibility:visible}.pxmail-meter i{display:block;height:100%;width:0;background:repeating-linear-gradient(90deg,#2f8bff 0 6px,#8cc8ff 6px 8px);transition:width 120ms steps(4)}' +
    '.pxmail-msg{display:block;margin-top:6px;font:8px/1.6 "Press Start 2P",monospace;letter-spacing:.12em;color:#8cc8ff;min-height:1.6em}' +
    '.pxready{animation:pxready .8s steps(2) infinite}' +
    '@keyframes pxready{50%{box-shadow:0 0 0 2px #000,0 0 26px #2f8bff}}' +
    '@keyframes pxblink{50%{opacity:0}}' +
    '@keyframes pxcrt{0%{opacity:1}60%{opacity:.6}100%{opacity:0;visibility:hidden}}' +
    '@keyframes pxcrtl{0%{transform:scaleX(0)}40%{transform:scaleX(1)}100%{transform:scaleX(1) scaleY(80);opacity:0}}' +
    '@keyframes pxach-in{0%{transform:translateY(140%)}8%,88%{transform:none}100%{transform:translateY(140%)}}' +
    /* F-26: on phones the achievement sat on top of ADD TO CART and the cart's checkout button, so it drops in under the header instead */
    '@keyframes pxach-top{0%{transform:translateY(-40px);opacity:0}8%,88%{transform:none;opacity:1}100%{transform:translateY(-40px);opacity:0}}' +
    '@media (max-width:749px){.pxach,.pxsticky .pxach{top:calc(var(--header-height,64px) + 8px);bottom:auto!important;animation-name:pxach-top}}' +
    '@keyframes pxfx-flash{from{opacity:1}to{opacity:0}}' +
    '@keyframes pxfx-pop{0%{transform:scale(.2);opacity:0}12%{transform:scale(1.15);opacity:1}20%{transform:scale(1)}80%{transform:scale(1);opacity:1}100%{transform:scale(.9);opacity:0}}' +
    '@media (prefers-reduced-motion:reduce){.pxfx__box,.pxach,.pxready,.pxhud__blink{animation:none!important}.pxcrt{display:none}}' +
    '.pxmus{bottom:52px}' +
    '.pxtrust{margin:14px 0 0;padding:12px 14px;border:2px solid rgb(47 139 255/.45);background:rgb(5 12 26/.85);font:9px/1.9 "Press Start 2P",monospace;letter-spacing:.08em;color:#8cc8ff}' +
    '.pxtrust b{color:#ffd166;font-weight:400}.pxtrust p{margin:0}.pxtrust a{color:#e2f0ff}' +
    '.pxbuy{position:fixed;left:0;right:0;bottom:0;z-index:2147483030;display:flex;align-items:center;gap:12px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:rgb(2 4 10/.97);border-top:2px solid #2f8bff;box-shadow:0 -6px 24px rgb(47 139 255/.25);transform:translateY(110%);transition:transform .25s steps(5)}' +
    '.pxbuy.is-on{transform:none}.pxbuy__t{flex:1;min-width:0;font:9px/1.5 "Press Start 2P",monospace;color:#e2f0ff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.pxbuy__t span{display:block;color:#ffd166}.pxbuy__t b{font-weight:400}' +
    '.pxbuy__b{flex:none;min-height:48px;padding:0 18px;font:11px/1 "Press Start 2P",monospace;letter-spacing:.08em;color:#02040a;background:#2f8bff;border:2px solid #8cc8ff;cursor:pointer}.pxbuy__b[disabled]{cursor:not-allowed;color:rgb(226 240 255/.85);background:#050c1a;border-color:#2a4f86}' +
    '.pxsticky .pxsnd{bottom:84px}.pxsticky .pxmus{bottom:124px}.pxsticky .pxach{bottom:84px}' +
    '@media (max-width:749px){.pxsticky .pxsnd{bottom:80px}.pxsticky .pxmus{bottom:122px}}' +
    '@media (max-width:749px){.pxsnd{left:8px;right:auto;top:auto;bottom:8px;width:36px;height:36px;min-height:0;padding:0;font-size:0;opacity:.85}.pxsnd::before{content:"♫";display:block;font:15px/32px monospace;text-align:center}.pxmus{bottom:50px}.pxmus::before{content:"♪"}.pxsnd[aria-pressed=false]::before{opacity:.35;text-decoration:line-through}.pxsticky .pxsnd{bottom:80px}.pxsticky .pxmus{bottom:122px}.pxsnd{transition:opacity .2s}.pxscrolled .pxsnd{opacity:0;pointer-events:none}}' +
    /* Phones, product page and /cart: the SOUND/MUSIC buttons covered the size buttons (S) and the free shipping bar, so they are not shown there */
    '@media (max-width:749px){body[data-px-template=product] .pxsnd,body[data-px-template=cart] .pxsnd{display:none!important}}' +
    '.pxsg-btn{display:inline-flex;align-items:center;gap:8px;min-height:44px;margin:10px 0 4px;padding:8px 12px;font:9px/1.4 "Press Start 2P",monospace;letter-spacing:.08em;color:#8cc8ff;background:transparent;border:2px dashed rgb(47 139 255/.6);cursor:pointer}.pxsg-btn:hover{color:#e2f0ff;border-style:solid}' +
    '.pxsg{position:fixed;inset:0;z-index:2147483300;display:grid;place-items:center;padding:16px;background:rgb(0 0 0/.72)}' +
    '.pxsg__box{position:relative;width:min(520px,100%);max-height:calc(100vh - 32px);overflow:auto;padding:22px 20px;background:#050c1a;border:3px solid #2f8bff;box-shadow:0 0 0 3px #000,0 0 40px rgb(47 139 255/.6);color:#e2f0ff;font:14px/1.6 system-ui,sans-serif}' +
    '.pxsg__box h2{margin:0 36px 14px 0;font:13px/1.5 "Press Start 2P",monospace;letter-spacing:.06em;color:#e2f0ff;text-shadow:0 0 8px #2f8bff}.pxsg__box h3{margin:18px 0 6px;font:9px/1.5 "Press Start 2P",monospace;letter-spacing:.1em;color:#ffd166}' +
    '.pxsg__box p,.pxsg__box li{margin:0 0 6px;color:#cfe3ff}.pxsg__box ul{margin:0;padding-left:18px}' +
    '.pxsg__x{position:absolute;top:10px;right:10px;width:36px;height:36px;font:14px/1 monospace;color:#e2f0ff;background:#02040a;border:2px solid #2f8bff;cursor:pointer}' +
    '.pxsg table{width:100%;border-collapse:collapse;margin:4px 0 6px;font:11px/1.6 "Press Start 2P",monospace}.pxsg th,.pxsg td{padding:8px 6px;border:1px solid rgb(47 139 255/.4);text-align:center}.pxsg th{color:#8cc8ff;font-weight:400}' +
    '.pxsg__pick{display:flex;gap:8px;flex-wrap:wrap;margin:6px 0}.pxsg__pick button{min-width:64px;min-height:44px;padding:0 12px;font:10px/1 "Press Start 2P",monospace;color:#e2f0ff;background:#02040a;border:2px solid rgb(47 139 255/.5);cursor:pointer}.pxsg__pick button[aria-pressed=true]{background:#2f8bff;color:#02040a;border-color:#8cc8ff}' +
    '.pxsg__res{min-height:1.6em;color:#ffd166}.pxsg tr.is-rec td{background:rgb(47 139 255/.28);color:#e2f0ff;box-shadow:inset 0 0 0 1px #2f8bff}' +
    '.pxship{margin:0 0 12px;padding:10px 12px;border:2px solid rgb(47 139 255/.45);background:rgb(5 12 26/.85);font:9px/1.7 "Press Start 2P",monospace;letter-spacing:.06em;color:#8cc8ff}.pxship b{color:#ffd166;font-weight:400}' +
    '.pxship__bar{display:block;height:8px;margin-top:8px;background:#02040a;border:1px solid rgb(47 139 255/.5)}.pxship__bar i{display:block;height:100%;background:repeating-linear-gradient(90deg,#2f8bff 0 6px,#8cc8ff 6px 8px);transition:width .3s steps(6)}' +
    '.pxship.is-free{color:#e2f0ff;border-color:#ffd166}';
  document.head.appendChild(css);

  /* ---------- Sound ---------- */
  /* SPEED (opgave 43): ONE shared sound engine for paix-fx.js and the home arcade (window.__pxAudio). The first one in a
     browser takes 0.5-1 s to create, so it is never created inside a tap or key press. A tap only wakes it up (resume);
     sounds and music start when it is awake. ADD TO CART / BUY NOW never wait.
     SPEED (F-31): it is no longer created while the page loads (that was the longest task on every page, 0.9-1.5 s on a
     phone). It is created in idle time after the customer's first tap or key press, see warmAudio() below. */
  var actx = null;
  /* VOLUME (opgave 44, Omar: "lyden er høj"): every sound on the site goes through ONE master volume on the shared engine.
     0.4 = 40 % of the level before 15/10. Music has its own bus under the master: 0.4 x 0.75 = 30 % of before.
     The home arcade (paix-arcade.js) uses the same master node; the game (paix-game.js) scales its own sounds by 0.4. */
  var MASTER = 0.4, MUSIC_LEVEL = 0.75;
  function pxOut(a) {
    if (!a.__pxMaster) { var g = a.createGain(); g.gain.value = MASTER; g.connect(a.destination); a.__pxMaster = g; }
    return a.__pxMaster;
  }
  function pxAudio(create) {
    var a = window.__pxAudio || null;
    if (!a && create) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (AC) { try { a = window.__pxAudio = new AC(); } catch (e) { a = null; } }
    }
    return a;
  }
  /* The browser only lets sound start after the customer's first tap (sticky user activation) */
  function tapped() { return !navigator.userActivation || navigator.userActivation.hasBeenActive; }
  function awake(a, fn) {
    if (a.state === 'running') { try { fn(a); } catch (e) {} return; }
    if (a.state === 'suspended' && tapped()) a.resume().then(function () { if (a.state === 'running') { try { fn(a); } catch (e) {} } }, function () {});
  }
  /* F-31: true while the customer's last tap (or Enter) was on a link that opens another page. That page makes its own
     engine, so this one is not made then: it would only slow the click down. Shared with paix-arcade.js. */
  function navTarget(e) {
    if (e.type === 'keydown' && e.key !== 'Enter') return false;
    var l = e.target && e.target.closest && e.target.closest('a[href]');
    return !!l && !/^(#|javascript:)/i.test(l.getAttribute('href') || '');
  }
  window.__pxNavTap = false;
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { window.__pxNavTap = navTarget(e); }, { capture: true, passive: true });
  });
  /* Runs fn with a running engine. If none exists yet, it is created after the next frame, so the tap that asked is never slowed */
  function withAudio(fn) {
    var a = pxAudio(false);
    if (a) { actx = a; awake(a, fn); return; }
    if (!tapped() || window.__pxNavTap) return;
    requestAnimationFrame(function () { setTimeout(function () { if (window.__pxNavTap) return; var b = pxAudio(true); if (b) { actx = b; awake(b, fn); } }, 0); });
  }
  /* F-31: the engine is warmed up in idle time after the first tap or key press that stays on this page (not a link to
     another page, not a buy button that is busy adding to the cart). Nothing happens while the page loads. */
  (function warmAudio() {
    var EVS = ['pointerdown', 'touchstart', 'keydown'];
    var BUSY = '[name=add], .add-to-cart-button, .pxbuynow__btn, .pxbuy__b, [name=checkout]';
    function warm() { if (soundOn() && !pxAudio(false)) actx = pxAudio(true); }
    function first(e) {
      if (window.__pxNavTap || (e.target && e.target.closest && e.target.closest(BUSY))) return;
      EVS.forEach(function (ev) { document.removeEventListener(ev, first, true); });
      if (pxAudio(false) || !soundOn()) return;
      if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 300);
    }
    EVS.forEach(function (ev) { document.addEventListener(ev, first, { capture: true, passive: true }); });
  })();
  function beep(freqs, step, dur, vol, type) {
    if (!soundOn()) return;
    withAudio(function (a) {
      freqs.forEach(function (f, i) {
        var t = a.currentTime + i * (step || 0), o = a.createOscillator(), g = a.createGain();
        o.type = type || 'square'; o.frequency.setValueAtTime(f, t);
        g.gain.setValueAtTime(vol || 0.03, t); g.gain.exponentialRampToValueAtTime(0.0001, t + (dur || 0.12));
        o.connect(g).connect(pxOut(a)); o.start(t); o.stop(t + (dur || 0.12) + 0.02);
      });
    });
  }
  var SFX = {
    /* add to cart: loud ITEM GET jingle */
    item: function () { beep([988, 1319, 1568, 2093, 2637], 0.07, 0.2, 0.11); beep([247, 330, 392, 523], 0.07, 0.22, 0.09, 'triangle'); },
    ach: function () { beep([523, 659, 784, 1047], 0.09, 0.2, 0.035); },
    key: function () { beep([1200 + Math.random() * 400], 0, 0.03, 0.007); },
    ready: function () { beep([784, 1175], 0.08, 0.12, 0.02); },
    hover: function () { beep([660], 0, 0.035, 0.005); },
    /* louder blip when touching shop things (products, sizes, buy buttons) */
    shop: function () { beep([880, 1175], 0.03, 0.06, 0.03); },
    start: function () { beep([392, 523, 659, 784, 1047], 0.08, 0.16, 0.035); },
    click: function () { beep([880, 1320], 0.04, 0.06, 0.01); },
    coin: function () { beep([988, 1319], 0.08, 0.14, 0.07); },
    /* short, quiet level-up (about 0.23 s) on ADD TO CART, BUY NOW and the cap "Add" in the cart drawer */
    buy: function () { beep([784, 1047, 1319, 1568], 0.04, 0.09, 0.03); },
    /* big jackpot fanfare after a purchase */
    bigwin: function () { beep([523, 659, 784, 1047, 784, 1047, 1319, 1568, 2093], 0.09, 0.3, 0.2); beep([131, 165, 196, 262, 196, 262, 330, 392, 523], 0.09, 0.32, 0.25, 'triangle'); setTimeout(function () { beep([2093, 1568, 2093, 2637, 3136], 0.07, 0.28, 0.18); beep([262, 392, 523, 659], 0.07, 0.3, 0.22, 'triangle'); }, 900); },
    /* special power-up sweep when something is bought with points */
    redeem: function () { beep([262, 330, 392, 523, 659, 784, 1047, 1319, 1568, 2093], 0.04, 0.12, 0.09); setTimeout(function () { beep([1568, 2093, 2637, 3136], 0.05, 0.18, 0.1, 'triangle'); }, 450); }
  };

  /* ---------- Background music: a small original chiptune loop (starts after the first click/tap, paused while the game runs) ---------- */
  function musicOn() { return read('pxMusic') !== 'off' && soundOn(); }
  var music = { timer: 0, step: 0, next: 0, gain: null };
  var BPM = 112, SPB = 60 / BPM / 2; // eighth notes
  // A minor -> F -> C -> G progression, 8 steps per chord
  var BASS = [110, 110, 165, 110, 87.3, 87.3, 131, 87.3, 130.8, 130.8, 196, 130.8, 98, 98, 147, 98];
  var ARP = [[440, 523, 659, 523], [349, 440, 523, 440], [523, 659, 784, 659], [392, 494, 587, 494]];
  function note(f, t, d, type, vol) {
    var o = actx.createOscillator(), g = actx.createGain();
    o.type = type; o.frequency.setValueAtTime(f, t);
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + d);
    o.connect(g).connect(music.gain); o.start(t); o.stop(t + d + 0.02);
  }
  function schedule() {
    if (!actx) return;
    var paused = document.hidden || !musicOn() || document.querySelector('.px-game');
    music.gain.gain.setTargetAtTime(paused ? 0 : MUSIC_LEVEL, actx.currentTime, 0.3);
    if (paused) { music.next = actx.currentTime + 0.1; return; }
    while (music.next < actx.currentTime + 0.25) {
      var i = music.step, chord = Math.floor(i / 8) % 4, t = music.next;
      if (i % 2 === 0) note(BASS[(Math.floor(i / 2)) % 16], t, SPB * 1.8, 'triangle', 0.022);
      note(ARP[chord][i % 4] * (i % 16 < 8 ? 1 : 2), t, SPB * 0.9, 'square', 0.004);
      if (i % 8 === 4) note(60, t, 0.08, 'sawtooth', 0.01); // soft kick
      music.step = (i + 1) % 64; music.next += SPB;
    }
  }
  function startMusic() {
    if (music.timer || music.starting || !musicOn()) return;
    music.starting = true;
    /* Same shared engine; it starts when the engine is awake, the tap itself never waits for it */
    withAudio(function (a) {
      music.starting = false;
      if (music.timer || !musicOn()) return;
      music.gain = a.createGain(); music.gain.gain.value = 0; music.gain.connect(pxOut(a));
      music.next = a.currentTime + 0.1;
      music.timer = setInterval(schedule, 100);
    });
    setTimeout(function () { music.starting = false; }, 3000);
  }
  function stopMusic() { if (music.timer) { clearInterval(music.timer); music.timer = 0; if (music.gain) music.gain.gain.value = 0; } }
  if (read('pxMusic') === null) save('pxMusic', 'on');
  ['pointerdown', 'keydown'].forEach(function (ev) { document.addEventListener(ev, function () { startMusic(); }, { once: true, capture: true }); });
  /* Any sound button (SOUND, MUSIC, the arcade's SOUND on the home page) sends px:sound */
  document.addEventListener('px:sound', function () { if (musicOn()) startMusic(); else stopMusic(); });
  function musicToggle() {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'pxsnd pxmus';
    function render() { var on = musicOn(); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? '♪ MUSIC ON' : '♪ MUSIC OFF'; }
    render();
    document.addEventListener('px:sound', render);
    b.addEventListener('click', function () { var on = musicOn(); save('pxMusic', on ? 'off' : 'on'); if (!on && !soundOn()) setSound(true); render(); if (!on) startMusic(); else stopMusic(); });
    B.appendChild(b);
  }

  /* ---------- ITEM GET! on add to cart ---------- */
  function burst(host) {
    if (reduce) return;
    var colors = ['#8cc8ff', '#2f8bff', '#e2f0ff', '#6f7bff'];
    for (var i = 0; i < 28; i++) {
      var p = document.createElement('i');
      p.className = 'pxfx__px';
      p.style.background = colors[i % colors.length];
      host.appendChild(p);
      var ang = (i / 28) * Math.PI * 2, dist = 120 + Math.random() * 160;
      p.animate([{ transform: 'translate(-50%,-50%)', opacity: 1 }, { transform: 'translate(' + (Math.cos(ang) * dist - 3) + 'px,' + (Math.sin(ang) * dist - 3) + 'px)', opacity: 0 }],
        { duration: 700 + Math.random() * 400, easing: 'steps(8)', fill: 'forwards' });
    }
  }
  var busy = false;
  function banner(title, sub) {
    if (busy) return;
    busy = true;
    var host = document.createElement('div');
    host.className = 'pxfx';
    host.setAttribute('role', 'status');
    host.innerHTML = '<div class="pxfx__flash"></div><div class="pxfx__box"><p class="pxfx__title"></p><p class="pxfx__sub"></p></div>';
    host.querySelector('.pxfx__title').textContent = title;
    host.querySelector('.pxfx__sub').textContent = sub;
    B.appendChild(host);
    burst(host);
    setTimeout(function () { host.remove(); busy = false; }, 1800);
  }
  function celebrate(amountEuro) {
    var pts = amountEuro > 0 ? Math.floor(amountEuro * RATE) : 0;
    banner('ITEM GET!', pts ? (loggedIn ? T('+' + pts + ' PTS AFTER CHECKOUT', '+' + pts + ' POINT EFTER KØB') : T('LOG IN TO EARN ' + pts + ' PTS', 'LOG IND OG FÅ ' + pts + ' POINT')) : T('ADDED TO CART', 'LAGT I KURVEN'));
    SFX.item();
    achieve('first-item', 'FIRST LOOT', '★');
  }
  function amountFrom(data) {
    if (!data) return 0;
    var items = data.items || (data.id ? [data] : []);
    return items.reduce(function (s, it) { return s + (it.final_line_price || it.line_price || it.price * (it.quantity || 1) || 0); }, 0) / 100 / (Number(CUR.rate) || 1);
  }
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = (init && init.method) || (input && input.method) || 'GET';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url.split('#')[0].split('?')[0] + '?')) p.then(shipSoon, function () {});
    if (/\/cart\/add(\.js)?(\?|$)/.test(url.split('#')[0]) && String(method).toUpperCase() === 'POST') {
      p.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (d) { if (!d.status) celebrate(amountFrom(d)); }, function () { celebrate(0); });
      }).catch(function () {});
    }
    return p;
  };

  /* ---------- Achievements (saved in this browser) ---------- */
  var achQueue = [], achBusy = false;
  /* M5 (opgave 63, købsrejse 16/10): no ACHIEVEMENT UNLOCKED boxes in front of the shopping (shop, product pages, cart).
     They are still unlocked there, just without the box; on the other pages (game, story, profile) they show as before. */
  var achQuiet = /^(product|collection|cart)/.test(D.pxTemplate || '');
  function achieve(id, title, icon) {
    var key = 'pxAch:' + id;
    if (read(key)) return;
    save(key, '1');
    if (achQuiet) return;
    achQueue.push([title, icon || '◆']);
    if (!achBusy) nextAch();
  }
  function nextAch() {
    var a = achQueue.shift();
    if (!a) { achBusy = false; return; }
    achBusy = true;
    var el = document.createElement('div');
    el.className = 'pxach';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="pxach__icon" aria-hidden="true"></span><div><p class="pxach__k">ACHIEVEMENT UNLOCKED</p><p class="pxach__t"></p></div>';
    el.querySelector('.pxach__icon').textContent = a[1];
    el.querySelector('.pxach__t').textContent = a[0];
    B.appendChild(el);
    SFX.ach();
    setTimeout(function () { el.remove(); nextAch(); }, reduce ? 3000 : 4300);
  }

  /* ---------- Live e-mail fields: react to every keystroke ---------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function wireEmail(input) {
    if (input.dataset.pxmail) return;
    input.dataset.pxmail = '1';
    input.classList.add('pxmail');
    var meter = document.createElement('span'); meter.className = 'pxmail-meter'; meter.setAttribute('aria-hidden', 'true');
    var fill = document.createElement('i'); meter.appendChild(fill);
    var msg = document.createElement('span'); msg.className = 'pxmail-msg'; msg.setAttribute('aria-live', 'polite');
    var anchor = input.closest('.pxd__row, .email-signup__input-group, .field') || input;
    anchor.insertAdjacentElement('afterend', msg);
    anchor.insertAdjacentElement('afterend', meter);
    var form = input.form;
    var btn = form && form.querySelector('[type=submit], button:not([type=button])');
    var wasValid = false, t = 0;
    input.addEventListener('input', function () {
      var v = input.value.trim();
      var valid = EMAIL.test(v);
      var pct = valid ? 100 : Math.min(90, (v.length / 18) * 90 + (v.indexOf('@') > 0 ? 20 : 0));
      fill.style.width = pct + '%';
      meter.classList.toggle('is-on', !!v); /* D-1: an empty meter looked like a broken field, so it shows once typing starts */
      input.classList.add('is-key');
      clearTimeout(t); t = setTimeout(function () { input.classList.remove('is-key'); }, 90);
      SFX.key();
      /* L1 (opgave 63): the drop list button says SIGN UP / TILMELD now, so the hint does too */
      msg.textContent = !v ? '' : valid ? T('✓ READY ▶ SIGN UP', '✓ KLAR ▶ TILMELD') : v.indexOf('@') < 1 ? 'ENTERING NAME...' : 'LOADING DOMAIN...';
      input.classList.toggle('is-valid', valid);
      if (btn) btn.classList.toggle('pxready', valid);
      if (valid && !wasValid) SFX.ready();
      wasValid = valid;
    });
    if (form) form.addEventListener('submit', function () {
      if (!EMAIL.test(input.value.trim())) return;
      save('pxPendingSignup', '1');
      if (btn) btn.textContent = 'SAVING...';
      msg.textContent = 'TRANSMITTING...';
      banner('PLAYER REGISTERED', 'WELCOME TO THE DROP LIST');
      SFX.item();
    });
  }
  function scanEmails() { document.querySelectorAll('input[type=email]').forEach(wireEmail); }

  /* ---------- Player HUD (every page except the arcade homepage) ---------- */
  function hud() {
    if (isHome) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    /* F-33 (opgave 63): layout/theme.liquid draws the bar on the server (snippets/paix-hud.liquid), so nothing jumps.
       Here only the points get the same number format as before (1,234 PTS). */
    var ssr = document.querySelector('.pxhud');
    if (ssr) {
      var pts = ssr.querySelector('[data-pxhud-pts]');
      if (pts && loggedIn) pts.textContent = Number(D.pxPoints || 0).toLocaleString('en-US') + ' PTS';
      return;
    }
    /* Omar 16/10 (a0863c9) + opgave 63 M5: no game bar where the customer shops (product pages, shop, cart) */
    if (/^(product|collection|cart)/.test(D.pxTemplate || '')) return;
    var bar = document.createElement('div');
    bar.className = 'pxhud';
    var left = loggedIn
      ? '<span>1UP <b data-pxhud-pts>' + Number(D.pxPoints || 0).toLocaleString('en-US') + ' PTS</b></span><span>LVL <b data-pxhud-lvl>' + (D.pxLevel || 'ROOKIE').toUpperCase() + '</b></span>'
      : '<span class="pxhud__blink">INSERT COIN</span>';
    var right = loggedIn ? '<a href="/pages/player">PLAYER PROFILE ▶</a>' : '<a href="' + (D.pxLogin || '/account/login') + '">LOGIN TO START ▶</a>';
    bar.innerHTML = '<div style="display:flex;gap:18px">' + left + '</div><div style="display:flex;gap:18px"><a href="/#play">PLAY ▶</a>' + right + '</div>';
    main.parentNode.insertBefore(bar, main);
  }

  /* ---------- PLAYER READY on login + welcome bonus (once per browser session) ---------- */
  function welcome() {
    if (!loggedIn) { try { sessionStorage.removeItem('pxReady'); } catch (e) {} return; }
    if (sread('pxReady')) return;
    ssave('pxReady', '1');
    origFetch('/apps/paix/me', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok || !/json/.test(r.headers.get('content-type') || '')) throw 0; return r.json(); })
      .then(function (d) {
        var pts = document.querySelector('[data-pxhud-pts]'), lvl = document.querySelector('[data-pxhud-lvl]');
        if (pts) pts.textContent = Number(d.points || 0).toLocaleString('en-US') + ' PTS';
        if (lvl && d.level) lvl.textContent = d.level.name;
        var tag = d.nickname || ('PLAYER ' + String(d.player_no || 1).padStart(3, '0'));
        var bonus = (d.history || []).filter(function (h) { return h.reason === 'signup'; })[0];
        var fresh = bonus && Date.now() - Number(bonus.created_at) < 30 * 60 * 1000 && !read('pxBonusShown');
        setTimeout(function () {
          if (fresh) {
            save('pxBonusShown', '1');
            banner('ITEM GET!', '+' + Number(bonus.delta).toLocaleString('en-US') + ' PTS WELCOME BONUS');
            SFX.item();
            achieve('welcome', 'NEW PLAYER JOINED', '★');
          } else {
            banner(tag + ' READY', Number(d.points || 0).toLocaleString('en-US') + ' PTS · LVL ' + (d.level ? d.level.name : ''));
            SFX.start();
          }
        }, isHome ? 1600 : 500);
      })
      .catch(function () {});
  }

  /* ---------- STAGE CLEAR: big win when a new order is registered on the player's account ---------- */
  function orderCheck() {
    if (!loggedIn) return;
    var lastChk = Number(sread('pxOrderChk') || 0);
    if (Date.now() - lastChk < 30000) return;
    ssave('pxOrderChk', String(Date.now()));
    origFetch('/apps/paix/me', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok || !/json/.test(r.headers.get('content-type') || '')) throw 0; return r.json(); })
      .then(function (d) {
        var seen = Number(read('pxLastOrderSeen') || 0);
        var orders = (d.history || []).filter(function (h) { return h.reason === 'order'; });
        var newest = orders.reduce(function (m, h) { return Math.max(m, Number(h.created_at) || 0); }, 0);
        if (!seen) { save('pxLastOrderSeen', String(newest || Date.now())); return; }
        var fresh = orders.filter(function (h) { return Number(h.created_at) > seen; });
        if (!fresh.length) return;
        save('pxLastOrderSeen', String(newest));
        var pts = fresh.reduce(function (s, h) { return s + (Number(h.delta) || 0); }, 0);
        setTimeout(function () {
          banner('STAGE CLEAR!', 'ORDER COMPLETE · +' + pts.toLocaleString('en-US') + ' PTS');
          SFX.bigwin();
          achieve('first-order', 'FIRST ORDER. LEGEND.', '♛');
        }, isHome ? 2000 : 700);
      })
      .catch(function () {});
  }

  /* ---------- Sound toggle (every page except the arcade homepage, which has its own) ---------- */
  function soundToggle() {
    if (isHome) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'pxsnd';
    function render() { b.setAttribute('aria-pressed', soundOn() ? 'true' : 'false'); b.textContent = soundOn() ? '♫ SOUND ON' : '♫ SOUND OFF'; }
    render();
    document.addEventListener('px:sound', render);
    b.addEventListener('click', function () { setSound(!soundOn()); SFX.ready(); });
    B.appendChild(b);
  }

  /* ---------- CRT power-on between pages ---------- */
  function crt() {
    return; /* disabled: the black power-on screen made every page feel slower */
    var c = document.createElement('div');
    c.className = 'pxcrt';
    B.appendChild(c);
    setTimeout(function () { c.remove(); }, 500);
  }

  /* ---------- Hover blips on buttons and products ---------- */
  var lastHover = null;
  document.addEventListener('pointerover', function (e) {
    var t = e.target.closest && e.target.closest('a, button, .button, .product-card, .variant-option__button-label, .menu-list__link, .pxp-btn, .pxs-item, summary, [role=button]');
    if (t && t !== lastHover) { lastHover = t; if (t.closest('.product-card, .variant-option__button-label, .pxs-item, [name=add], .add-to-cart-button, product-form-component')) SFX.shop(); else SFX.hover(); }
  });
  /* Click sounds: coin on buy/checkout buttons, blip on everything else (not inside the game, it has its own) */
  /* Buy buttons get one short level-up per press (pointer or keyboard). Only with SOUND on (beep checks it), never
     with reduced motion. Web Audio only schedules the notes, so adding to cart and BUY NOW's checkout never wait for it. */
  var BUY_SEL = '[name=add], .add-to-cart-button, .pxbuynow__btn, .pxbuy__b';
  var lastBuy = 0;
  function buySound(t) {
    var n = Date.now();
    if (reduce || !t || t.disabled || n - lastBuy < 500) return;
    lastBuy = n;
    SFX.buy();
  }
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('a, button, .button, summary, label, [role=button]');
    if (!t || t.closest('.px-game')) return;
    if (t.matches(BUY_SEL)) buySound(t); else if (t.matches('[name=checkout], .pxs-btn')) SFX.coin(); else if (t.closest('.product-card, .variant-option__button-label, product-form-component')) SFX.shop(); else SFX.click();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(BUY_SEL);
    if (t && !t.closest('.px-game')) buySound(t);
  }, true);


  /* ---------- Buy boost: trust info under the buy button, sticky ADD TO CART bar, reassurance in the cart ---------- */
  /* Shipping line by country (Liquid: snippets/paix-free-shipping.liquid, locales paix_cart.ship_trust_*) */
  function shipLine() {
    var sd = shipData();
    /* Campaign (task 60): free shipping in DK with a countdown; the normal line waits hidden for the end date */
    if (promoOn()) return '<p data-px-promo>' + sd.promo.trust + '</p>' + (sd.trust ? '<p data-px-promo-off hidden>' + sd.trust + '</p>' : '');
    return sd && sd.trust ? '<p>' + sd.trust + '</p>' : T('<p>&#10003; FAST SHIPPING WITH POSTNORD</p>', '<p>&#10003; HURTIG LEVERING MED POSTNORD</p>');
  }
  function ptsHTML(pts) {
    var login = '<a href="' + (D.pxLogin || '/account/login') + '">' + T('LOG IN', 'LOG IND') + '</a>';
    return '<b>&#9654; ' + (loggedIn ? T('+' + pts + ' PTS WITH THIS ORDER', '+' + pts + ' POINT MED DETTE KØB') : T(login + ' &amp; EARN ' + pts + ' PTS', login + ' &amp; FÅ ' + pts + ' POINT')) + '</b>';
  }
  function trustHTML(pts) {
    return (pts ? '<p>' + ptsHTML(pts) + '</p>' : '') +
      T('<p>&#10003; SECURE CHECKOUT &middot; MOBILEPAY, APPLE PAY &amp; CARDS</p><p>&#10003; 14-DAY RETURNS &middot; 24-MONTH WARRANTY</p>',
        '<p>&#10003; SIKKER BETALING &middot; MOBILEPAY, APPLE PAY &amp; KORT</p><p>&#10003; 14 DAGES RETURRET &middot; 24 MÅNEDERS REKLAMATIONSRET</p>') + shipLine();
  }
  /* Product data from the page (no network): title from the H1, type from Shopify's analytics meta,
     price in cents (visitor's currency) from the variant picker JSON or the visible price */
  function pagePriceText() {
    var el = document.querySelector('main product-price .price') || document.querySelector('product-price .price');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function parseCents(txt) {
    var s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    var m = s.match(/[.,](\d{2})$/);
    var whole = (m ? s.slice(0, -3) : s).replace(/[.,]/g, '');
    return Number(whole || 0) * 100 + (m ? Number(m[1]) : 0);
  }
  function pageProduct() {
    var am = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) || {};
    var h = document.querySelector('main h1') || document.querySelector('h1');
    var v = null;
    try { var j = document.querySelector('variant-picker script[type="application/json"]'); v = j ? JSON.parse(j.textContent) : null; } catch (e) {}
    var cents = v && typeof v.price === 'number' ? v.price : parseCents(pagePriceText());
    return { title: h ? h.textContent.replace(/\s+/g, ' ').trim() : '', type: am.type || '', cents: cents, variants: (am.variants || []).length };
  }
  /* The variant picker is re-rendered when the size changes; put the size guide back each time */
  var sgProduct = null;
  function sgAgain() {
    if (!sgProduct || document.querySelector('.pxsg-btn')) return;
    var form = document.querySelector('product-form-component form[action*="/cart/add"], form[action*="/cart/add"]:not([id^=QuickAdd])');
    try { sizeGuide(sgProduct, form); } catch (e) {}
  }
  function shopBoost() {
    var tpl = D.pxTemplate || '';
    if (tpl.indexOf('product') === 0) {
      var form = document.querySelector('product-form-component form[action*="/cart/add"], form[action*="/cart/add"]:not([id^=QuickAdd])');
      var btn = form && form.querySelector('button[name=add]');
      if (!btn) return;
      var host = form.closest('product-form-component') || form;
      /* F-34 (opgave 63): the product page draws the trust box on the server (blocks/paix-trust.liquid); only the points
         line is filled in here, in the line that was kept free for it. Other templates get the box from here, as before. */
      var box = (form.closest('.shopify-section') || document).querySelector('.pxtrust[data-pxtrust-ssr]');
      var ssrTrust = !!box;
      if (!box) {
        box = document.createElement('div'); box.className = 'pxtrust'; box.innerHTML = trustHTML(0);
        /* Under our own BUY NOW button (blocks/paix-buy-now.liquid) when it is there, so the two buttons stay together */
        var buyNow = (form.closest('.shopify-section') || document).querySelector('paix-buy-now');
        /* Opgave 63 D: the SIZE GUIDE block stands right under BUY NOW; the trust box comes after it */
        var after = buyNow || host, nx = after.nextElementSibling;
        while (nx && nx.tagName === 'SCRIPT') nx = nx.nextElementSibling;
        if (nx && nx.classList.contains('pxsg-btn')) after = nx;
        after.insertAdjacentElement('afterend', box);
      }
      /* Everything below reads the product from the page itself, so it still works when a network call fails (e.g. 429) */
      var p = pageProduct();
      sgProduct = p;
      try { sizeGuide(p, form); } catch (e) {}
      function setPoints(cents) {
        if (!(cents > 0)) return;
        var pts = Math.floor(toEur(cents / 100) * RATE);
        var line = ssrTrust && box.querySelector('[data-pxtrust-pts]');
        if (line) line.innerHTML = ptsHTML(pts); else if (!ssrTrust) box.innerHTML = trustHTML(pts);
      }
      if (p.cents > 0) setPoints(p.cents);
      else origFetch(location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }).then(function (j) { setPoints(j.price || 0); }).catch(function () {});
      var bar = document.createElement('div'); bar.className = 'pxbuy'; bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="pxbuy__t"></div><button type="button" class="pxbuy__b" tabindex="-1">' + T('ADD TO CART', 'LÆG I KURV') + ' &#9654;</button>';
      var title = bar.querySelector('.pxbuy__t'); title.textContent = p.title;
      /* M3 (opgave 63): the bar shows the chosen size (199,00 kr · STR. M), and asks for one when none is chosen yet */
      var pr = document.createElement('span'), prT = document.createTextNode(pagePriceText()), sz = document.createElement('b');
      pr.append(prT, sz); title.appendChild(pr);
      var bb = bar.querySelector('.pxbuy__b');
      function sizeNow() { return [].map.call(document.querySelectorAll('variant-picker fieldset input[type=radio]:checked'), function (i) { return i.value; }).join(' / '); }
      function noSize() { return !!document.querySelector('variant-picker fieldset input[type=radio]') && !sizeNow(); }
      bb.addEventListener('click', function () {
        if (noSize()) { var f = document.querySelector('variant-picker fieldset'); if (f) f.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); return; }
        btn.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); if (!btn.disabled) btn.click();
      });
      B.appendChild(bar);
      function sync() {
        var z = sizeNow(), none = noSize();
        bb.disabled = !none && !!btn.disabled;
        bb.textContent = none ? T('CHOOSE A SIZE', 'VÆLG STØRRELSE') : btn.disabled ? T('SOLD OUT', 'UDSOLGT') : T('ADD TO CART ▶', 'LÆG I KURV ▶');
        var price = pagePriceText() || prT.nodeValue.replace(/ · $/, '');
        prT.nodeValue = price + (z ? ' · ' : '');
        sz.textContent = z ? T('SIZE ', 'STR. ') + z : '';
      }
      new IntersectionObserver(function (en) {
        var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', off); B.classList.toggle('pxsticky', off); sync();
      }).observe(btn);
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker')) setTimeout(sync, 0); });
    }
    if (tpl.indexOf('cart') === 0) {
      var co = document.querySelector('[name=checkout]');
      if (co && !document.querySelector('.pxtrust')) { var t = document.createElement('div'); t.className = 'pxtrust'; t.innerHTML = trustHTML(0); co.insertAdjacentElement('afterend', t); }
    }
  }

  /* ---------- Size guide pop-up next to the size picker ---------- */
  /* Garment measurements in cm: [chest width armpit to armpit, length from the shoulder]. Fill in from Omar's numbers
     (team/udkast/2026-10-15-stoerrelsesmaal-skabelon.md); the table "MEASUREMENTS (CM)" then appears by itself.
     DA texts come from T(), FR from the dictionary in paix-i18n.js (same as the rest of this file).
     If one product differs, give it its own entry under byHandle with the product handle, e.g. 'paix-v1™-wc-edition-4'. */
  var SIZE_CM = {
    tee: null,          // e.g. { S: [52, 70], M: [55, 72], L: [58, 74], XL: [61, 76] }
    windbreaker: null,  // e.g. { S: [60, 70], M: [63, 72], L: [66, 74] }
    byHandle: {}
  };
  function sizeGuide(p, form) {
    var isJacket = /windbreaker|jacket|jakke/i.test((p.type || '') + ' ' + (p.title || ''));
    var kind = isJacket ? 'windbreaker' : 'tee';
    /* F-34 (opgave 63): the product page draws the button on the server (blocks/paix-size-guide.liquid), so ADD TO CART
       does not jump down. Then it is only wired up here. The old way (put in after the sizes) stays for other templates. */
    var b = document.querySelector('.pxsg-btn');
    if (b && b.hasAttribute('data-pxsg-on')) return;
    if (!b) {
      var picker = document.querySelector('variant-picker fieldset, .variant-picker fieldset, fieldset.variant-option');
      // No size guide on one-size products (e.g. the caps): one variant, or no size picker at all
      if (p.variants === 1 || (!picker && !p.variants)) return;
      var anchor = picker || form;
      if (!anchor) return;
      b = document.createElement('button');
      b.type = 'button'; b.className = 'pxsg-btn';
      b.innerHTML = '&#9638; ' + T('SIZE GUIDE', 'STØRRELSESGUIDE');
      anchor.insertAdjacentElement('afterend', b);
    }
    b.setAttribute('data-pxsg-on', '');
    var sizes = isJacket ? ['S', 'M', 'L'] : ['S', 'M', 'L', 'XL'];
    var handle = ''; try { handle = decodeURIComponent((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || ''); } catch (e) {}
    var cm = SIZE_CM.byHandle[handle] || SIZE_CM[kind];
    function rec(h, fit) {
      // Based on the model: 185 cm wears L (standard) / XL (oversized) in the tee, L (slightly oversized) in the jacket.
      var i = h < 168 ? 0 : h < 178 ? 1 : h < 190 ? 2 : 3;
      if (!isJacket && fit === 'over') i += 1;
      if (isJacket && fit === 'reg' && h >= 178 && h < 190) i = 1;
      return sizes[Math.max(0, Math.min(sizes.length - 1, i))];
    }
    function sizeInput(z) { return document.querySelector('variant-picker input[type=radio][value="' + z + '"], fieldset input[type=radio][value="' + z + '"]'); }
    /* Sold-out sizes are not disabled inputs: Horizon marks them with aria-disabled and data-option-available="false" */
    function sizeOk(z) {
      var i = sizeInput(z);
      return !!i && !i.disabled && i.getAttribute('aria-disabled') !== 'true' && i.getAttribute('data-option-available') !== 'false';
    }
    function nearest(z, fit) {
      var at = sizes.indexOf(z), up = fit === 'over';
      for (var d = 1; d < sizes.length; d++) {
        var a = sizes[at + (up ? d : -d)], b = sizes[at + (up ? -d : d)];
        if (a && sizeOk(a)) return a;
        if (b && sizeOk(b)) return b;
      }
      return '';
    }
    function open() {
      var host = document.createElement('div');
      host.className = 'pxsg'; host.setAttribute('role', 'dialog'); host.setAttribute('aria-modal', 'true');
      var table = cm ? '<h3>' + T('MEASUREMENTS (CM)', 'MÅL (CM)') + '</h3><table><tr><th>' + T('SIZE', 'STR.') + '</th><th>' + T('CHEST', 'BRYST') + '</th><th>' + T('LENGTH', 'LÆNGDE') + '</th></tr>' +
        sizes.filter(function (z) { return cm[z]; }).map(function (z) { return '<tr data-z="' + z + '"><td>' + z + '</td><td>' + cm[z][0] + '</td><td>' + cm[z][1] + '</td></tr>'; }).join('') + '</table><p>' + T('Chest is measured flat from armpit to armpit. Compare with a top you already own.', 'Brystmål er målt fladt fra ærmegab til ærmegab. Sammenlign med en trøje, du selv har.') + '</p>' : '';
      var fitTxt = isJacket
        ? T('<li>Relaxed fit. Our model is 185 cm and wears <b>L</b> for a slightly oversized look.</li><li>Between two sizes? Take the smaller one for a cleaner fit, the bigger one for more room over a hoodie.</li>',
            '<li>Afslappet pasform. Vores model er 185 cm og bruger <b>L</b> til et let oversized look.</li><li>Mellem to størrelser? Tag den mindste for en pænere pasform, den største for mere plads over en hoodie.</li>')
        : T('<li>Our model is 185 cm and wears <b>XL</b> for an oversized fit, or <b>L</b> for a standard fit.</li><li>Want it oversized? Go one size up from your usual size.</li>',
            '<li>Vores model er 185 cm og bruger <b>XL</b> til en oversized pasform eller <b>L</b> til en normal pasform.</li><li>Vil du have den oversized? Gå en størrelse op fra din normale størrelse.</li>');
      host.innerHTML = '<div class="pxsg__box"><button type="button" class="pxsg__x" aria-label="' + T('Close', 'Luk') + '">&#10005;</button>' +
        '<h2>&#9638; ' + T('FIND YOUR SIZE', 'FIND DIN STØRRELSE') + '</h2><ul>' + fitTxt + '</ul>' +
        '<h3>' + T('1. YOUR HEIGHT', '1. DIN HØJDE') + '</h3><div class="pxsg__pick" data-k="h">' +
        [['160', 165], ['170', 173], ['180', 182], ['190+', 192]].map(function (o) { return '<button type="button" data-v="' + o[1] + '">' + o[0] + '</button>'; }).join('') + '</div>' +
        '<h3>' + T('2. FIT', '2. PASFORM') + '</h3><div class="pxsg__pick" data-k="f"><button type="button" data-v="reg">' + T('REGULAR', 'NORMAL') + '</button><button type="button" data-v="over">OVERSIZED</button></div>' +
        '<p class="pxsg__res" aria-live="polite"></p>' + table +
        '<h3>' + T('NOT SURE?', 'I TVIVL?') + '</h3><p>' + T('You have a 14-day right of withdrawal. Return it and order the right size.', 'Du har 14 dages fortrydelsesret. Send den retur og bestil den rigtige størrelse.') + '</p></div>';
      var st = {};
      host.addEventListener('click', function (e) {
        if (e.target === host || e.target.closest('.pxsg__x')) { close(); return; }
        var btn = e.target.closest('.pxsg__pick button'); if (!btn) return;
        var grp = btn.parentNode; st[grp.dataset.k] = btn.dataset.v;
        grp.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
        SFX.click();
        if (st.h && st.f) {
          var z = rec(Number(st.h), st.f);
          /* H1 (opgave 63): never send the customer to a sold-out size. If the size is sold out, say so and pick the nearest
             size that can be bought (for OVERSIZED the bigger one first, else the smaller one). Only text and the choice. */
          var pick = sizeOk(z) ? z : nearest(z, st.f);
          var res = host.querySelector('.pxsg__res');
          if (pick === z) res.innerHTML = '&#9654; ' + T('WE RECOMMEND SIZE ', 'VI ANBEFALER STØRRELSE ') + '<b>' + z + '</b>';
          else if (pick) res.innerHTML = '&#9654; ' + T('SIZE ', 'STØRRELSE ') + '<b>' + z + '</b>' + T(' IS SOLD OUT. WE RECOMMEND ', ' ER UDSOLGT. VI ANBEFALER ') + '<b>' + pick + '</b>';
          else res.innerHTML = '&#9654; ' + T('SIZE ', 'STØRRELSE ') + '<b>' + z + '</b>' + T(' IS SOLD OUT.', ' ER UDSOLGT.');
          host.querySelectorAll('tr[data-z]').forEach(function (r) { r.classList.toggle('is-rec', r.getAttribute('data-z') === (pick || z)); });
          SFX.ready();
          var inp = pick && sizeInput(pick);
          if (inp && !inp.checked) inp.click();
        }
      });
      function key(e) { if (e.key === 'Escape') close(); }
      function close() { host.remove(); document.removeEventListener('keydown', key); b.focus(); }
      document.addEventListener('keydown', key);
      B.appendChild(host);
      host.querySelector('.pxsg__x').focus();
    }
    b.addEventListener('click', open);
  }

  /* ---------- Free shipping bar on the /cart page (Denmark, DKK only) ----------
     Threshold and texts come from Liquid (snippets/paix-free-shipping.liquid, locales paix_cart.*).
     The cart drawer renders its own bar at the top in Liquid, so it is skipped here. */
  var lastCart = null;
  var SHIP = null;
  function shipData() {
    if (SHIP == null) { try { var el = document.getElementById('PaixShipData'); SHIP = el ? JSON.parse(el.textContent) : false; } catch (e) { SHIP = false; } }
    return SHIP;
  }
  /* Euro amounts in the visitor's currency (SEK, NOK) with the shop's rate. DKK and EUR are exact from Liquid */
  function eurRate() { var r = Number(CUR.rate); return CUR.active && CUR.active !== 'EUR' && r > 0 ? r : 0; }
  /* Amounts in the shop's own money format (the same as Liquid `money` in the cart drawer), for every currency.
     Liquid renders a sample (1.234.567,89 in the visitor's currency) in #PaixShipData; its separators, prefix and suffix are reused. */
  function shopMoney(a, trimZeros) {
    var sd = shipData(), sample = sd && sd.money_sample ? String(sd.money_sample).replace(/<[^>]*>/g, '') : '';
    var m = sample.match(/1(\D?)234(\D?)567(\D)89/), n = !m && sample.match(/1(\D?)234(\D?)568/);
    if (!m && !n) return money(a);
    var cents = Math.round((Number(a) || 0) * 100), whole = Math.floor(cents / 100), frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, (m || n)[1]);
    var txt = m ? (trimZeros && frac === '00' ? w : w + m[3] + frac) : w;
    return sample.replace((m || n)[0], txt);
  }

  /* Campaign countdown (task 60, snippets/paix-free-shipping.liquid): Liquid sends the end time (unix seconds) and the
     texts in the visitor's language. Every [data-px-promo-left] gets the time left; at the end date the campaign elements
     ([data-px-promo]) go and the normal texts ([data-px-promo-off]) come back, without reloading the page. */
  var promoTimer = 0;
  function promoOn() { var sd = shipData(); return !!(sd && sd.promo && sd.promo.end * 1000 > Date.now()); }
  function promoLeft() {
    var p = shipData().promo, s = Math.max(0, Math.floor((p.end * 1000 - Date.now()) / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
    return d > 0 ? String(p.dh).replace('%D%', d).replace('%H%', h) : String(p.hm).replace('%H%', h).replace('%M%', m);
  }
  function promoPaint() {
    var sd = shipData();
    if (!sd || !sd.promo) return;
    if (!promoOn()) {
      sd.promo = false;
      clearInterval(promoTimer);
      document.querySelectorAll('[data-px-promo]').forEach(function (el) { el.remove(); });
      document.querySelectorAll('[data-px-promo-off]').forEach(function (el) { el.hidden = false; });
      shipBars();
      return;
    }
    var txt = promoLeft();
    document.querySelectorAll('[data-px-promo-left]').forEach(function (el) { if (el.textContent !== txt) el.textContent = txt; });
    if (!promoTimer) promoTimer = setInterval(promoPaint, 30000);
  }

  function shipLimit(sd) {
    if (sd.mode !== 'convert') return (sd.threshold || 0) / 100;
    var r = eurRate();
    return r ? Math.ceil((sd.threshold_eur || 0) / 100 * r) : 0; // round up: never promise free shipping below Shopify's own limit
  }
  function convertEur() {
    var r = eurRate();
    if (!r) return;
    document.querySelectorAll('[data-px-eur]:not([data-px-done])').forEach(function (el) {
      el.textContent = shopMoney(Math.ceil((Number(el.getAttribute('data-px-eur')) || 0) / 100 * r), true);
      el.setAttribute('data-px-done', '');
    });
  }
  /* Cart drawer bar for SEK/NOK: Liquid renders an empty bar with the euro threshold and the cart total */
  function shipTop() {
    var sd = shipData(), r = eurRate();
    if (!sd || !r) return;
    document.querySelectorAll('[data-px-ship-eur]').forEach(function (el) {
      var limit = Math.ceil((Number(el.getAttribute('data-px-ship-eur')) || 0) / 100 * r);
      var total = (Number(el.getAttribute('data-px-total')) || 0) / 100;
      if (!(limit > 0)) return;
      var left = Math.max(0, limit - total);
      var pct = Math.min(100, (total / limit) * 100);
      var html = left > 0 ? String(sd.left).replace('%AMOUNT%', shopMoney(Math.ceil(left))) : String(sd.free);
      var key = html + pct;
      if (el.dataset.k === key) return;
      el.dataset.k = key;
      el.classList.toggle('is-free', left <= 0);
      el.innerHTML = '<span>' + html + '</span><span class="pxship__bar" aria-hidden="true"><i style="width:' + pct + '%"></i></span>';
      el.hidden = false;
    });
  }
  function shipBars() {
    var sd = shipData();
    if (!sd || !sd.on || !lastCart) return;
    var limit = shipLimit(sd);
    if (!(limit > 0)) return;
    var total = (lastCart.total_price || 0) / 100;
    var left = Math.max(0, limit - total);
    var pct = Math.min(100, (total / limit) * 100);
    var html = left > 0 ? String(sd.left).replace('%AMOUNT%', shopMoney(sd.mode === 'convert' ? Math.ceil(left) : left)) : String(sd.free);
    if (promoOn()) { left = 0; pct = 100; html = String(sd.promo.bar).replace(/(data-px-promo-left[^>]*>)[^<]*/, '$1' + promoLeft()); }
    document.querySelectorAll('[name=checkout]').forEach(function (co) {
      if (co.closest('#cart-drawer')) return;
      var box = co.parentNode.querySelector(':scope > .pxship');
      if (!lastCart.item_count) { if (box) box.remove(); return; }
      if (!box) { box = document.createElement('div'); box.className = 'pxship'; co.insertAdjacentElement('beforebegin', box); }
      var key = html + pct;
      if (box.dataset.k === key) return;
      box.dataset.k = key;
      box.classList.toggle('is-free', left <= 0);
      box.innerHTML = '<span>' + html + '</span><span class="pxship__bar" aria-hidden="true"><i style="width:' + pct + '%"></i></span>';
    });
  }
  function refreshCart() {
    origFetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { lastCart = c; shipBars(); }).catch(function () {});
  }
  var shipT = 0;
  function shipSoon() { clearTimeout(shipT); shipT = setTimeout(refreshCart, 350); }
  document.addEventListener('cart:update', shipSoon);

  /* Phone: the small sound buttons hide while scrolling so they never cover products or prices */
  var scrollT = 0;
  window.addEventListener('scroll', function () {
    B.classList.add('pxscrolled');
    clearTimeout(scrollT);
    scrollT = setTimeout(function () { if (window.scrollY < 120) B.classList.remove('pxscrolled'); }, 250);
    if (window.scrollY < 120) B.classList.remove('pxscrolled');
  }, { passive: true });

  /* Visitors in Denmark see the Danish version once automatically; after that their own language choice is kept */
  function danishOnce() {
    if (DA || LANG.indexOf('en') !== 0 || window.Shopify && Shopify.country !== 'DK') return false;
    if (!window.Shopify || read('pxLangAuto')) return false;
    save('pxLangAuto', '1');
    var root = (Shopify.routes && Shopify.routes.root) || '/';
    if (root !== '/') return false;
    location.replace('/da' + location.pathname + location.search + location.hash);
    return true;
  }
  if (danishOnce()) return;

  /* SPEED (opgave 63): things the customer does not need for the first view (sound buttons, achievements, the welcome
     banner and the order check) start when the page has loaded and the browser is idle, so they do not compete with
     the product photos. Nothing is removed: everything still runs, a moment later. */
  function afterLoad(fn) {
    function go() { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 200); }
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  }
  function start() {
    crt();
    hud();
    scanEmails();
    try { shopBoost(); } catch (e) {}
    var moT = 0;
    new MutationObserver(function () { scanEmails(); clearTimeout(moT); moT = setTimeout(function () { shipBars(); sgAgain(); convertEur(); shipTop(); promoPaint(); }, 120); }).observe(B, { childList: true, subtree: true });
    /* The cart is only read here for the free shipping bar on the /cart page; other pages read it after a cart change (shipSoon) */
    if ((D.pxTemplate || '').indexOf('cart') === 0) refreshCart();
    convertEur(); shipTop(); promoPaint();
    afterLoad(function () {
      soundToggle();
      musicToggle();
      welcome();
      setTimeout(orderCheck, 2500);
      achievements();
    });
    /* Extras (weekly tournament, notify-me) live in their own file next to this one */
    try {
      /* Opgave 63: the address from Liquid has the file's version (?v=). Without it the CDN kept a copy from 15/10 for a
         year (max-age 31557600), so changes to paix-extra.js did not reach the customers. */
      var self = document.querySelector('script[src*="/paix-fx.js"]');
      if ((D.pxExtra || self) && !document.querySelector('script[src*="/paix-extra.js"]')) {
        var x = document.createElement('script'); x.src = D.pxExtra || self.src.split('?')[0].replace(/paix-fx\.js$/, 'paix-extra.js'); x.defer = true; document.head.appendChild(x);
      }
    } catch (e) {}
  }
  function achievements() {
    var tpl = D.pxTemplate || '';
    if (tpl.indexOf('product') === 0) achieve('first-product', 'GEAR INSPECTED', '◉');
    if (tpl.indexOf('collection') === 0) achieve('first-shop', 'ENTERED THE SHOP', '▣');
    if (/about-us|story/.test(location.pathname)) achieve('lore', 'LORE UNLOCKED', '✦');
    if (location.search.indexOf('customer_posted=true') !== -1 || read('pxPendingSignup')) {
      if (location.search.indexOf('customer_posted=true') !== -1) achieve('drop-list', 'JOINED THE DROP LIST', '✉');
      try { localStorage.removeItem('pxPendingSignup'); } catch (e) {}
    }
    if (loggedIn) achieve('player-one', 'PLAYER ONE READY', '☺');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.PaixFx = { celebrate: celebrate, achieve: achieve, banner: banner, play: function (n) { if (SFX[n]) SFX[n](); } };
})();